import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style.css'
import axios from './plugins/axios'
import CKEditor from '@ckeditor/ckeditor5-vue';
import Loading from './components/commons/Loading.vue' 
import ConfirmAction from './components/commons/ConfirmAction.vue' 
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser,faCircleCheck } from '@fortawesome/free-regular-svg-icons'; 
import lowercase from './directives/lowercase'


import DashboardLayout from './components/layout/DashboardLayout.vue'
//import EmptyLayout from './components/EmptyLayout.vue'

import { faCalendar, faCalendarCheck, faBars,faXmark,faUserPen,faLock ,faCircleUser ,faMoneyBill ,faMoneyBillTrendUp,faBus,faMoneyCheckDollar,faFileCircleQuestion,faUsers,faChevronDown,faEye,faEyeSlash,faFilePen,faRectangleXmark,faPrint,faCheck ,faTrashCan,faExclamationTriangle ,faFileArrowUp } from '@fortawesome/free-solid-svg-icons'
/* add icons to the library */
library.add(faCalendar, faCalendarCheck, faBars,faXmark,faUser,faUserPen,faLock,faCircleUser,faMoneyBill,faMoneyBillTrendUp,faBus,faMoneyCheckDollar,faFileCircleQuestion,faUsers ,faChevronDown,faEye,faEyeSlash,faFilePen,faCircleCheck,faRectangleXmark,faPrint,faCheck,faCircleCheck,faTrashCan,faExclamationTriangle ,faFileArrowUp )

const token = localStorage.getItem('token')
const user = localStorage.getItem('user')

if (token && user) {
  store.commit('authentication/addWebToken', {
    token,
    ...JSON.parse(user)
  })
}



const app = createApp(App)

app.directive('lowercase', lowercase)

app.component('DefaultLayout', DashboardLayout)
app.component('Loading', Loading) // <- registro global
app.component('ConfirmAction', ConfirmAction) // <- registro global
app.component('font-awesome-icon', FontAwesomeIcon)


//app.component('EmptyLayout', EmptyLayout)

app.config.globalProperties.$http = axios;

app.use(router)
app.use(store) 
app.use(CKEditor);
app.mount('#app')
